import { Route, Routes } from "react-router-dom";

import QuizPage from "../page/QuizPage";

export const Router = ({ mode, changeMode }) => {
  return (
    <Routes>
      <Route path="/*" element={<QuizPage />} />
    </Routes>
  );
};

export default Router;
